import { createContext, useContext } from 'react';

// El modal de cambio de empresa pertenece a Layout. Las superficies anidadas
// usan esta acción para abrir ese mismo modal, sin duplicar su estado ni lógica.
export const CompanySwitcherActionContext = createContext(null);

export function useCompanySwitcherAction() {
  return useContext(CompanySwitcherActionContext);
}
